import { PiUsersThree } from "react-icons/pi";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateCreateGroupData } from "../../../store/Slices/CreateGroupSlice";
import { MdCheck } from "react-icons/md";
import toast from "react-hot-toast";
import { RxCross2 } from "react-icons/rx";
import { useState } from "react";

export default function GroupNameInput() {
  const dispatch = useAppDispatch();
  const [showToast, setShowToast] = useState(true);
  const CreateGroup = useAppSelector((state) => state.CreateGroup);

  const handleValueChange = (newValue: React.ChangeEvent<HTMLInputElement>) => {
    if (newValue.nativeEvent.inputType === "deleteContentBackward") {
      dispatch(updateCreateGroupData({ group_name: newValue.target.value }));
      setShowToast(true);
      return;
    }

    if (CreateGroup.group_name.length < CreateGroup.group_name_limit) {
      dispatch(updateCreateGroupData({ group_name: newValue.target.value }));
    } else if (showToast) {
      toast.error(
        `Group Name should only contain ${CreateGroup.group_name_limit} letters`,
        { position: "bottom-left" },
      );
      setShowToast(false);
    }
  };

  const invalid =
    CreateGroup.group_name.length >= CreateGroup.group_name_limit ||
    CreateGroup.group_name.length == 0;

  return (
    <div className="flex items-center gap-3 py-1">
      <PiUsersThree className="shrink-0 text-xl text-themeColor" />
      <input
        type="text"
        placeholder="Group Name"
        value={CreateGroup.group_name}
        onChange={handleValueChange}
        className="min-w-0 flex-1 border-none bg-transparent text-[17px] text-darkText outline-none placeholder:text-lightText"
      />
      <span className="shrink-0 text-[12px] text-lightText">
        {CreateGroup.group_name.length}/{CreateGroup.group_name_limit}
      </span>
      {invalid ? (
        <RxCross2 className="shrink-0 text-lg text-[#FF3B30]" />
      ) : (
        <MdCheck className="shrink-0 text-lg text-emerald-500" />
      )}
    </div>
  );
}
